import React from 'react';
import LandingTemplate from '../landing-template';
import { HeaderText, Underline } from 'components/shared/landing/main-header';
import styles from './styles.module.scss';

const MathAssessmentPhone = () => (
  <LandingTemplate
    fields={{
      phone: {
        validation: value => String(value).replace(/\D/g, '').length === 10,
        validationMessage: "Please check the format of your phone number and try again.",
        label: {
          htmlFor: "phone",
          labelContent: "Phone Number"
        },
        input: {
          id: "phone",
          name: "phone",
          type: "text",
          placeholder: "Enter phone number here",
          className: "form-control"
        }
      }
    }}
    header={<HeaderText className={styles.mathValueProp}>Personalized analysis of<br/><Underline>your child's Math readiness</Underline></HeaderText>}
    headerSubtext="Use this limited time offer to identify any gaps in Math readiness, and receive 1-on-1 feedback from a certified educator on best next steps"
    formButtonText="Get Started"
    formTitle="See where you child stands"
    formTitleSubtext="Enter your email to get a $125 value for $40!"
    campaignName="Math Assessment (Phone)"
  />
);

export default MathAssessmentPhone;
